"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @function addressesReducer
 * @param state
 * @param action
 * @returns addresses state
 */
var addresses_1 = require("../../actions/addresses");
function addressesReducer(state, action) {
    if (state === void 0) { state = addresses_1.DefaultState; }
    switch (true) {
        case action.type.includes(addresses_1.BUILD_ADDRESS): {
            var newState = Object.assign({}, state);
            newState = action.addressData;
            return newState;
        }
        case action.type.includes(addresses_1.REMOVE_ADDRESS): {
            var newState = Object.assign({}, state);
            newState.addressData = action.addressData;
            return newState;
        }
        case action.type.includes(addresses_1.MAKE_PRIMARY): {
            var newState = Object.assign({}, state.typeOfAction);
            newState = action.modifiedAddressesObj;
            return newState;
        }
        case action.type.includes(addresses_1.TYPE_ACTION):
            return tslib_1.__assign(tslib_1.__assign({}, state), { typeOfAction: action.typeOfAction });
        case action.type.includes(addresses_1.REMOVE_TOAST): {
            var newState = Object.assign({}, state);
            newState.typeOfAction = action.typeOfAction;
            // newState.addresses["typeOfAction"] = action.typeOfAction;
            return newState;
        }
        case action.type.includes(addresses_1.REMOVE_BILLING_ADD_ADDRESS): {
            var newState = Object.assign({}, state);
            newState.removeBilling = action.removeBilling;
            return newState;
        }
        case action.type.includes(addresses_1.UPDATE_FORM):
            return tslib_1.__assign(tslib_1.__assign({}, state), { updatedForm: action.updatedForm });
        default:
            return state;
    }
}
exports.default = addressesReducer;
